import React from 'react';
import { useEffect } from 'react';

import * as styles from 'src/uglib_styles/studySpacesListHeader.module.css'

function StudySpacesListHeader ({search_id}) {	

	useEffect(() => {
		let bookable = document.getElementById('bookable');
		let dropin = document.getElementById('dropin');
		let tech = document.getElementById('tech');
		let quiet = document.getElementById('quiet');
		let occupancy = document.getElementById('room-occupancy');
		let reset_button = document.getElementById('reset');

		bookable.onclick = update;
		dropin.onclick = update;
		tech.onclick = update;
		quiet.onclick = update;
		occupancy.onchange = update;
		reset_button.onclick = reset_filters;

		function update() {
			show_all();
			filter_amenities();
			filter_occupancy();
		}
		
		/**
		 * Filter to spaces that meet the amenity criteria
		 * 
		 * Starts off by hiding all rooms and then shows the ones that match the criteria.
		 */
		function filter_amenities() {
		
			let bookable_val = document.getElementById('bookable').checked;
			let dropin_val = document.getElementById('dropin').checked;
			let tech_val = document.getElementById('tech').checked;
			let quiet_val = document.getElementById('quiet').checked;
		
			let mask = [bookable_val, dropin_val, tech_val, quiet_val];
			let values = ["Bookable", "Drop-in", "Tech", "Quiet"];
			let filtered_values = values.filter((item, i) => mask[i])
		
			if(filtered_values.length === 0) {
				return;
			}
			else if(filtered_values.length === 1) {
				hide_all();
				filter_bookable();
				filter_dropin();
				filter_tech();
				filter_quiet();
			} else {
				const nodes = filtered_values.map((value) => {
					return get_data_nodes(value);
				})
			   
				hide_all();
		
				let results = nodes[0];
				for (let i=1; i < nodes.length; i++) {
					results = array_intersect(results, nodes[i]);
				}
				
				results.forEach((item) => {
					item.parentNode.classList.remove('invisible');
				});
			}
		}
		
		/**
		 * Hide spaces that can't accommodate the group size
		 */
		function filter_occupancy() {
			let occupancy_val = document.getElementById('room-occupancy').value;
		
			if(occupancy_val !== 0) {
				let nodes = get_visible_data_nodes();
				nodes.forEach((item) => {
					let value = Number(item.getAttribute('data-occupancy'));
					if (value < occupancy_val) {
						item.parentNode.classList.add('invisible');
					}
				})
			}
		}
		
		function array_intersect(array1, array2) {
			let results = [];
		
			for(let i=0; i < array1.length; i++) {
				for(let j=0; j < array2.length; j++) {
					if(array1[i] === array2[j] ) {
						results.push(array1[i]);
					}
				}
			}
		
			return results;
		}
		
		// Find all the visible data nodes - Spans that contain the data attributes that we need to filter. 
		function get_visible_data_nodes() {
			let query_string = `:not(.invisible) .data`;
			return document.querySelectorAll(query_string);
		}
		
		// Get data nodes that match our
		function get_data_nodes(amenity) {
			let query_string = `.data[data-amenities*="${amenity}"]`;
			return document.querySelectorAll(query_string);
		}
		
		function filter_bookable() {
			let filter_val = document.getElementById('bookable').checked;
		
			if (filter_val) {
				let items = get_data_nodes("Bookable");
		
				items.forEach((item) => {
					item.parentNode.classList.remove('invisible');
				});
			}
		}
		
		function filter_dropin() {
			let filter_val = document.getElementById('dropin').checked;
		
			if (filter_val) {
				let items = get_data_nodes("Drop-in");
				items.forEach((item) => {
					item.parentNode.classList.remove('invisible');
				});
			}
		}
		
		function filter_tech() {
			let fitler_val = document.getElementById('tech').checked;
		
			if (fitler_val) {
				let items = get_data_nodes("Tech");
		
				items.forEach((item) => {
					item.parentNode.classList.remove('invisible');
				});
			}
		}
		
		function filter_quiet() {
			let fitler_val = document.getElementById('quiet').checked;
		
			if (fitler_val) {
				let items = get_data_nodes("Quiet");
		
				items.forEach((item) => {
					item.parentNode.classList.remove('invisible');
				});
			}
		}
		
		function hide_all() {
			let all_items = document.querySelectorAll('#spaces-list li.space');
			all_items.forEach((item) => {
				item.classList.add('invisible');
			})
		}
		
		function show_all() {
			let items = document.querySelectorAll('#spaces-list li.space');
			items.forEach((item) => {
				item.classList.remove('invisible');
			});
		}
		
		function reset_filters() {
			document.getElementById('bookable').checked = false;
			document.getElementById('dropin').checked = false;
			document.getElementById('tech').checked = false;
			document.getElementById('quiet').checked = false;
			document.getElementById('room-occupancy').value = 0;
		
			show_all();
		}
		
	});

	return (<>
		<div id={styles.spaces_header}>
			<label for="bookable">
				<input type="checkbox" id="bookable" name="bookable" aria-controls="spaces-list" />
				<span>Bookable</span>
			</label>
			<label for="dropin">
				<input type="checkbox" id="dropin" name="dropin" aria-controls="spaces-list" />
				<span>Drop-in</span>
			</label>
			<label for="tech">
				<input type="checkbox" id="tech" name="tech" aria-controls="spaces-list" />
				<span>Technology</span>
			</label>
			<label for="quiet">
				<input type="checkbox" id="quiet" name="quiet" aria-controls="spaces-list" />
				<span>Quiet</span>
			</label>
			<label for="room-occupancy">
				<span>Group size</span>
				<select name="room-occupancy" id="room-occupancy" aria-controls="spaces-list">
					<option value="0">-</option>
					<option value="1">1</option>
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4+</option>
				</select>
			</label>
			<button className="btn btn-secondary" id="reset" aria-controls="spaces-list">Reset</button></div>	
	</>)
}

export default StudySpacesListHeader